import { Component, Input, Renderer2, EventEmitter, Output } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PropertyGroup, QueovalItem, HtmlBase, BObjectModel, PropertyData, FormatDate, BObjectSummary } from '../../../../models';
import { ToastService } from '../../../../toast';
import { parseTime } from '../../../../utilities';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomDatepickerI18n, I18n } from '../../../../services';
import { BaseAddOnComponent } from '../base-addon.component';
import { ChangeDetectorRef } from '@angular/core';
import { AfterViewInit } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css', '../../dynamictag.component.css'],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }] // define custom NgbDatepickerI18n provide

})

export class DatepickerComponent extends BaseAddOnComponent implements AfterViewInit {

  // #region VARIABLES GLOBALES

  // #region public
  public input: PropertyData;
  public cycleElEntryPoint: string = '';
  // #endregion

  // #region private
  private dateDebutFinInput: PropertyData | undefined;
  // #endregion

  // #endregion

  // #region DIRECTIVES
  // tslint:disable-next-line:no-input-rename
  @Input('model') model: BObjectModel;
  @Input('input')
  set SetInput(pValue: any) {
    this.input = pValue;
    if (this.input.MainElementList) {
      let dateDebutFinSummary: BObjectSummary | undefined;
      //#region récupération dans le BoModel de la dateFin si mask DateDébut ou inversement
      switch (this.input.MainElementList[0].Mask) {
        case 'DATEDEBUT':
          dateDebutFinSummary = this.model.summary.find(sum => sum.Mask == 'DATEFIN');
          if (dateDebutFinSummary) {
            this.dateDebutFinInput = this.model.Body.SelectedGroupsList[dateDebutFinSummary.IndexGroupsList].DataList[dateDebutFinSummary.IndexDataList];
          }
          break;
        case 'DATEFIN':
          dateDebutFinSummary = this.model.summary.find(sum => sum.Mask == 'DATEDEBUT');
          if (dateDebutFinSummary) {
            this.dateDebutFinInput = this.model.Body.SelectedGroupsList[dateDebutFinSummary.IndexGroupsList].DataList[dateDebutFinSummary.IndexDataList];
          }
          break;
      }
      //#endregion

      //si une date valide est renseignée ou que l'on est en mode date début/fin,  on fait le getDate
      if ((this.input.MainElementList[0].Value !== '' && this.input.MainElementList[0].Value !== '00/00/0000') || this.input.MainElementList[0].Mask == 'DATEDEBUT' || this.input.MainElementList[0].Mask == 'DATEFIN') {
        const splitedDate: Array<string> = this.input.MainElementList[0].Value.split(`/`);
        this.getDate(`${splitedDate[2]}-${splitedDate[1]}-${splitedDate[0]}`, this.input);
      }
      //sinon la date est initialisée à null
      else {
        this.input.MainElementList[0].ValueGeneric = null;
        this.input.MainElementList[0].Value = `00/00/0000`;
      }
    }
  }

  @Output() sendDate: EventEmitter<Date> = new EventEmitter<Date>(true);
  @Output() navig: EventEmitter<HtmlBase> = new EventEmitter<HtmlBase>(false);
  //   // #endregion

  // #region CONSTRUCTEUR
  constructor(
    public render: Renderer2,
    private toastservice: ToastService,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer,
    public cd: ChangeDetectorRef,
  ) { super(); }
  //   // #endregion

  // #region FONCTIONS PUBLIQUES
  public ngAfterViewInit(): void {
    if (this.input.MainElementList[0].Mask == 'DATEDEBUT' && this.dateDebutFinInput) {
      const splitedDate: Array<string> = this.dateDebutFinInput.MainElementList[0].Value.split(`/`);
      this.getDate(`${splitedDate[2]}-${splitedDate[1]}-${splitedDate[0]}`, this.dateDebutFinInput);
      this.compareDate('DATEDEBUT');
    }
  }
  /**
   * Affecte la date de l'input au model
   * sous forme de string jj/MM/yyyy dans mainElementList.Value
   * sous forme de Date? dans mainElementList.ValueGeneric
   * @param pValue string date retourné par l'input (format yyyy-MM-jj)
   */
  public OnBlur(pValue: string): void {
    //élément de l'input type date dans lequel stoquer la date (sans les heures)
    const mainElementList: HtmlBase = this.input.MainElementList[0];
    if (pValue !== '') {
      this.getDate(pValue, this.input)
    }
    else {
      mainElementList.ValueGeneric = null;
      mainElementList.Value = `00/00/0000`;
    }
    this.compareDate(mainElementList.Mask);
  }

  /**
   * affecte au model l'heure ou la minute sélectionnée dans le select
   * MainElementList[1] correspond à l'heure
   * MainElementList[2] correspond aux minutes
   * @param pValue valeur de l'option sélectionnée
   * @param pType hour ou min selon que le select soit celui pour les heures ou les minutes
   * @param pSelectOptionsList liste des options du select
   */
  public OnSelectChange(pValue: string, pType: string, pSelectOptionsList: QueovalItem[]): void {

    //sélectionne la bonne option dans la liste
    pSelectOptionsList.forEach(option => {
      option.Selected = option.Value === pValue;
    });

    //récupère la date en coupant la référence
    // afin que lors de la modification de la date
    // le ngModel détecte le changement de valeur
    const ValueGeneric = new Date(this.input.MainElementList[0].ValueGeneric);
    const nbValue: number = Number(pValue);
    switch (pType) {
      case 'hour':
        //change les heures
        ValueGeneric.setHours(nbValue);
        this.input.MainElementList[1].Value = parseTime(nbValue);
        break;
      case 'min':
        //change les minutes
        ValueGeneric.setMinutes(nbValue);
        this.input.MainElementList[2].Value = parseTime(nbValue);
        break;
    }
    //affecte la nouvelle date pour trigger le ngModel
    this.input.MainElementList[0].ValueGeneric = ValueGeneric;

    this.compareDate(this.input.MainElementList[0].Mask);
  }

  /**
   * Ouvre la modal de la gestion des cycles elearning ou émet l'événement au dynamictag
   * pour avoir le comportement générique qui y est implémenté
   * @param pButton HtmlBase sur lequel on clique
   * @param pContent modal à ouvrir (dans le cas du type MODAL)
   */
  public OnClickButton(pButton: HtmlBase, pContent: any): void {
    switch (pButton.TypeModal.toUpperCase()) {
      case 'MODAL':
        if (this.input) {
          if (!this.model.IdDonneeFils || this.model.IdDonneeFils == '0') {
            this.toastservice.showWarningToast(`Impossible d'affecter un cycle avant d'avoir créer l'objet.`)
          } else {
            this.cycleElEntryPoint = pButton.MoreValues['Table'];
            this.OpenModal(pContent)
          }
        }
        break;
      default:
        this.navig.emit(pButton);
    }
  }

  public updateValueInput(value: string): void {
    this.input.MainElementList[0].ValueGeneric = value;
  }

  // #endregion

  // #region FONCTIONS PRIVEES
  private OpenModal(content: any) {
    this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'qmodalover modal-datepicker' }).result.then();
  }

  /**
   * en mode dateDébut/dateFin fait en sorte que toujours soit respecté dateDébut < dateFin
   * @param pMask DATEDEBUT ou DATEFIN
   */
  private compareDate(pMask: string): void {
    // on ne fait la comparaison que si le Bo possède les propriétés date avec les deux mask (DATEDEBUT et DATEFIN)
    // et que la date modifiée possède l'un de ces deux mask
    if (this.dateDebutFinInput) {
      let minute: number = 0;
      let hour: number = 0;
      let day: number = 0;
      let currentDate: Date = this.input.MainElementList[0].ValueGeneric;
      let update: boolean = false;
      switch (pMask.toUpperCase()) {
        case 'DATEDEBUT':
          if (currentDate >= this.dateDebutFinInput.MainElementList[0].ValueGeneric) {
            update = true;
            //#region si la date de fin est de type date avec heure
            if (this.dateDebutFinInput.MainElementList.length > 2) {
              minute = currentDate.getMinutes();
              hour = currentDate.getHours();
              //si on modifie la date de début et qu'elle dépasse la date de fin
              // on modifiera la date de fin
              if (minute < 30) {
                minute += 30;
              } else {
                minute -= 30;
                hour += 1;
              }
            }
            //#endregion
            //#region si la date de fin est de type date SANS heures
            else if (this.input.MainElementList.length > 2) {
              day++;
            }
            //#endregion
          }
          break;

        case 'DATEFIN':
          if (currentDate <= this.dateDebutFinInput.MainElementList[0].ValueGeneric) {
            update = true;
            //#region si la date de début est de type date avec heure
            if (this.dateDebutFinInput.MainElementList.length > 2) {
              minute = currentDate.getMinutes();
              hour = currentDate.getHours();
              //si on modifie la date de fin et qu'elle est inférieure la date de début
              // on modifiera la date de début
              if (minute < 30) {
                minute += 30;
                hour -= 1;
              } else {
                minute -= 30;
              }
            }
            //#endregion
            //#region si la date de début est de type date SANS heures
            else if (this.input.MainElementList.length > 2) {
              day--;
            }
            //#endregion
          }
          break;
      }

      if (update) {
        //si après recalcul des heures la valeur atteint -1
        // hour == -1 => 23h et on fera -1 jour
        if (hour < 0) {
          day = -1
          hour = 23;
        }
        //#region affectation des valeurs calculées
        this.dateDebutFinInput.MainElementList[0].ValueGeneric = new Date(this.input.MainElementList[0].ValueGeneric);
        this.dateDebutFinInput.MainElementList[0].ValueGeneric.setMinutes(minute);
        this.dateDebutFinInput.MainElementList[0].ValueGeneric.setHours(hour);

        if (this.dateDebutFinInput.MainElementList.length > 2) {

          this.dateDebutFinInput.MainElementList[1].Value = parseTime(hour);
          this.dateDebutFinInput.MainElementList[1].SelectOptionsList.forEach((option: QueovalItem) => {
            option.Selected = Number(option.Value) === hour;
          });

          this.dateDebutFinInput.MainElementList[2].Value = parseTime(minute);
          this.dateDebutFinInput.MainElementList[2].SelectOptionsList.forEach((option: QueovalItem) => {
            option.Selected = Number(option.Value) === minute;
          });
        }

        //#endregion

        // update la date
        if (day != 0) {
          this.dateDebutFinInput.MainElementList[0].ValueGeneric.setDate(this.dateDebutFinInput.MainElementList[0].ValueGeneric.getDate() + day);
          this.dateDebutFinInput.MainElementList[0].Value = `${parseTime(this.dateDebutFinInput.MainElementList[0].ValueGeneric.getDate())}/${parseTime(this.dateDebutFinInput.MainElementList[0].ValueGeneric.getMonth() + 1)}/${this.dateDebutFinInput.MainElementList[0].ValueGeneric.getFullYear()}`;
        } else {
          this.dateDebutFinInput.MainElementList[0].Value = this.input.MainElementList[0].Value;
        }
      }

    }
  }

  /**
   * gère l'affectation de la date à l'init et au blur de l'input
   * @param pStrDate format yyyy-MM-jj
   */
  private getDate(pStrDate: string, pPorpertyData: PropertyData): void {
    // déclaration de la date du jour
    const dateOfDay: Date = new Date();
    const dayOfDay: number = dateOfDay.getDate();
    const monthOfDay: number = dateOfDay.getMonth() + 1;
    const yearOfDay: number = dateOfDay.getFullYear();

    // renvoie la date du jour si la date récupérée est 0000-00-00
    const lstDate: Array<string> = pStrDate.split('-');
    let year: number = Number(lstDate[0]);
    //si l'année = '0000' => année en cours || si l'année < 100 => 20XX (XX compris entre 01 et 99) || sinon => valeur saisie
    year = lstDate[0] === '0000' ? yearOfDay : year < 100 ? Number(`20${parseTime(year)}`) : Number(lstDate[0]);
    const month: number = lstDate[1] === '00' ? monthOfDay : Number(lstDate[1]);
    const day: number = lstDate[2] === '00' ? dayOfDay : Number(lstDate[2]);
    const hour: number = pPorpertyData.MainElementList.length > 1 ? Number(pPorpertyData.MainElementList[1].Value) : 0;
    const minute: number = pPorpertyData.MainElementList.length > 2 ? Number(pPorpertyData.MainElementList[2].Value) : 0;

    // les mois sont décalés de 1 à cause du rang du premier argument d'une liste qui est 0
    pPorpertyData.MainElementList[0].ValueGeneric = new Date(year, month - 1, day, hour, minute, 0, 0);
    // affection de la date au datepicker
    pPorpertyData.MainElementList[0].Value = `${parseTime(pPorpertyData.MainElementList[0].ValueGeneric.getDate())}/${parseTime(pPorpertyData.MainElementList[0].ValueGeneric.getMonth() + 1)}/${pPorpertyData.MainElementList[0].ValueGeneric.getFullYear()}`;
  }
  // #endregion
}

